//import React from "react";
import { AES, enc } from "crypto-js";

export const getDecryptedData = (cipher: string): string => {
  try {
    
    const decryptedBytes = AES.decrypt(cipher, "my-secret-key-@#$");
    
    const decryptedData = decryptedBytes.toString(enc.Utf8);

    return decryptedData;
  } catch (error:any) {
    
    console.error('Error decrypting data:', error);
    return ""; 
  }
};
